@import "../../variables.scss";

.resource {
  &__wrapper {
    border: #d0d0d0 1px solid;
    margin: 1rem 0;
    padding: 1rem;
    @media (max-width: $size-sm) {
      margin: 0 0 15px;
      padding: 0;
      border: unset;
    }
  }
  &__title {
    @media (max-width: $size-sm) {
      background-color: rgba(0, 30, 83, 0.2);
      margin: 0px -1rem;
      padding: 1rem;
    }
  }

  &__description {
    color: $color-grey;
    max-width: 600px;

    @media (max-width: $size-xl) {
      width: calc(100% - 120px - 1rem);
    }

    @media (max-width: $size-sm) {
      width: 100%;
      margin-top: 1rem;
    }
  }
  &__button {
    width: 120px;
    height: 40px;
  }

  &__blueOutline {
    border-color: #2196f3;
  }
}
